import { Col, useScopedSelector, AttachFileIcon } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { Time } from 'omni-package-react-core';
import { StyledHeader, StyledRightCol, StyledContainer, StyledRow, StyledLink, StyledSubject, StyledTime } from './MessagesRowsPhone.styles';
import { Message } from '../../../../../../interfaces/Message';
import { SecuredMessagingState } from '../../../../../../interfaces/SecuredMessagingState';
import { getTabName } from '../../../../utils/securedMessagingHelper';
import Constants from '../../../../../../Constants';

export interface MessagesRowsPhoneProps {
  message: Message;
}

const MessagesRowsPhone: FC<MessagesRowsPhoneProps> = ({ message }) => {
  const activeTab: number = useScopedSelector((state: SecuredMessagingState) => state.messagesTabs?.selectedTab);
  const attachmentsCount = useMemo(() => message.attachments?.length, [message.attachments?.length]);

  const isSent = useMemo(() => activeTab === 1, [activeTab]);
  const messageSource = useMemo(() => isSent ? 'Outbox' : 'Inbox', [isSent]);

  const params = new URLSearchParams(window.location.search);
  params.set('messageSource', getTabName(activeTab));
  params.set('page', params.get(`messagesResource${messageSource}`) ? params.get(`messagesResource${messageSource}`) : '1');
  const newSearch = params.toString();

  return (
    <StyledContainer fluid unread={message.isNew}>
      <StyledLink to={`${Constants.MessageDetailsPagePath}/${encodeURIComponent(message.id)}?${newSearch}`}>
        <StyledRow unread={message.isNew}>
          <Col xs={9} p={0}>
            <StyledTime><Time time={new Date(message.activationDateUTC)} /></StyledTime>
            <StyledHeader>{message.subjectGroupDescription}</StyledHeader>
            <StyledSubject unread={message.isNew}>{message.subjectDescription}</StyledSubject>
          </Col>
          <StyledRightCol xs={3} p={0}>
            {(attachmentsCount) > 0 && (<AttachFileIcon />)}
          </StyledRightCol>
        </StyledRow>
      </StyledLink>
    </StyledContainer>
  );
};
export default MessagesRowsPhone;
